import {createSelector} from 'reselect'

const stateReducer = state => state.authReducer;

export const getProfile = (initData) =>
    createSelector(
        stateReducer,
        authReducer => authReducer.user
    )

// export const getFetchingPayment = (initData) =>
//     createSelector(
//         stateReducer,
//         orderReducer => orderReducer.isPayment
//     )
//
// export const getDataOrderItem = (initItems) =>
//     createSelector(
//         stateReducer,
//         orderReducer => Object.keys(initItems?.item || {}).length > 0 ? initItems?.item : orderReducer.detail?.item
//     )
//
// export const getErrors = (initItems) =>
//     createSelector(
//         stateReducer,
//         orderReducer => orderReducer.errors
//     )
//
// export const getDataUpdate = (initItems) =>
//     createSelector(
//         stateReducer,
//         orderReducer => orderReducer.url
//     )
